
window.addEventListener("scroll", function () {
  const header = document.querySelector(".l_header");
  const fv = document.querySelector(".js-fv");
  if (window.scrollY > fv.offsetHeight) {
    header.classList.add("is-active");
  } else {
    header.classList.remove("is-active");
  }
});

// let moreBtn = document.querySelector(".p_aboutTxtBox_icon");
// let aboutTxt = document.querySelector(".p_aboutTxtBox");
// moreBtn.addEventListener("click", function () {
//   moreBtn.classList.toggle("is-hidden");
//   if (moreBtn.classList.contains("is-hidden")) {
//     aboutTxt.classList.add("is-active");
//   } else {
//     moreBtn.classList.remove("is-hidden");
//   }
// });


